import Vue from 'vue'
import {ValidationObserver, ValidationProvider, extend, localize, configure} from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'
import moment from 'moment';

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('postCode', {
  message: '{_field_}のフォーマットが正しくありません',
  validate: value => {
    // check if bracket valid
    if(!/\{[0-9]+\}/g.test(value)) {
      return false;
    }
    const replaceValue = value.replace(/\{[0-9]+\}/g, '');
    if(replaceValue.length === 0) {
      return true;
    }

    return /^[ -]+$/g.test(replaceValue);
  }
})

extend('phoneNumber', {
  message: 'ハイフンをを除く半角数字12桁以内で入力してください  ',
  validate: value => {
    if (value) {
        const regex = new RegExp('^[0-9]{0,12}$', 'g');
        return regex.test(value);
    }

    return false;
  }
})
extend('phoneSplit', {
  message: '{_field_}は必須項目です ',
  validate: value => {
    if (value) {
        let full = value.f + value.m + value.l
        if (!full.length) {
          return false;
        }
    }

    return true;
  }
})

extend("decimal", {
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value),
    };
  },
  message: '小数点を入力してください。'
})

extend('formula', {
  message: '無効な文字が含まれています。有効な文字：+,-,*,/, ,@,(,)',
  validate: value => {
    const regex = new RegExp('^[\\+\\-\\/\\*\\@\\s\\d\\(\\)]+$', 'g')

    return regex.test(value)
  }
})

extend('required_date', {
  message: '{_field_}は必須項目です',
  validate: (value, params) => {
    return Object.values(value).every(Boolean);
  }
})

extend('maxTags', {
  message: (value, params) => {
    return `${params[0]}つの項目しか選択できない`
  },
  validate: (value, params) => {
    return value.length <= params[0]
  }
})
extend('minTags', {
  message: (value, params) => {
    return `${params[0]}つ以上選択してください`
  },
  validate: (value, params) => {
    return value.length >= params[0]
  }
})


extend('isKana', {
  message: 'カタカナで入力してください',
  validate: value => {
    return /^([ァ-ン]|ー)+$/g.test(value);
  }
})

extend('date_format', {
  message: '{_field_}付が正しい形式ではありません',
  validate: function(value, args) {
    const format = args[0]?.replace(/[^a-zA-Z]/g, '/');
    let str = format;

    const dateEmpty = Object.values(value).every(Boolean);
    if(!dateEmpty) {
      return true;
    }

    for(let key in value) {
      const convertValue = ['yy', 'mm', 'dd'].includes(key.toLowerCase()) ? value[key]?.padStart(2, '0') : value[key]
      str = str.replace(key, convertValue);
    }

    const date = moment(str, format, true);
    return date.isValid();
  }
})

extend('date_between', {
  message: '{_field_}は{min}から{max}の間でなければなりません',
  params: ['min', 'max', 'date_format'],
  validate: (value, {min, max, date_format}) => {
    const format = date_format.format || date_format;
    let str = format.replace(/[^a-zA-Z]/g, '/');

    const dateEmpty = Object.values(value).every(Boolean);
    if(!dateEmpty) {
      return true;
    }

    for(let key in value) {
      const convertValue = ['mm', 'dd'].includes(key.toLowerCase()) ? value[key]?.padStart(2, '0') : value[key]
      str = str.replace(key, convertValue);
    }

    const date = moment(str, date_format);

    if(!min && !max) {
      return false;
    }

    if(min && max) {
      return date.isBetween(moment(min), moment(max), undefined, '[]');
    }

    if(min) {
      return date.isSameOrAfter(moment(min));
    } else {
      return date.isSameOrBefore(moment(max));
    }
  }
})

extend('max_character', {
  message: '{max}桁数以内で入力してください。',
  params: ['max'],
  validate: (value, {max}) => {
    if (value.toString().length > max) {
      return false;
    }
    return true;
  }
})

extend('date_after', {
  message: '{min}より後の日付を指定してください。',
  params: ['min'],
  validate: (value, {min}) => {
    if (value['d'] && value['m'] && value['y']) {
      if (!min) {
        return false;
      }

      const val = Date.parse(`${value['y']}/${value['m']}/${value['d']}`);

      return val >= Date.parse(min);
    }

    return true;
  }
})

extend('check_price', {
  message: '100以上で入力してください。',
  validate: (value) => {
    const minPrice = 100

    if (!value || value == '0' || value >= minPrice) {
      return true
    }

    return false;
  }
})

extend('plan_storage', {
  message: 'ストレージで小数点第二位まで入力してください。',
  validate: (value) => {
    if (String(value).split(".")[1] && String(value).split(".")[1]?.length > 2) {
      return false
    }
    return true
  }
})

extend('less_than', {
  message: '上限数を超えています。{max}以下で入力してください。',
  params: ['max'],
  validate: (value, {max}) => {
    return Number(value) < Number(max);
  }
})

ja.messages.min_value = "{min}以上で入力してください。"
ja.messages.max_value = "上限数を超えています。{max}以下で入力してください。"
localize('ja', ja)

configure({
  classes: {
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
  }
})

Vue.component('validation-observer', ValidationObserver)
Vue.component('validation-provider', ValidationProvider)
